/**
 * @license
 * Copyright Endlessjs. All Rights Reserved.
 * Licensed under the MIT License. See License.txt in the project root for license information.
 */

import { NgModule, ModuleWithProviders } from '@angular/core';

import { ElSharedModule } from '../shared/shared.module';
import { ElMenuComponent, ElMenuItemComponent } from './menu.component';
import { ElMenuService, ElMenuInternalService } from './menu.service';
import { ElIconModule } from '../icon/icon.module';

const elMenuComponents = [ElMenuComponent, ElMenuItemComponent];

const EL_MENU_PROVIDERS = [ElMenuService, ElMenuInternalService];

@NgModule({
  imports: [ElSharedModule, ElIconModule],
  declarations: [...elMenuComponents],
  exports: [...elMenuComponents],
})
export class ElMenuModule {
  static forRoot(): ModuleWithProviders {
    return <ModuleWithProviders>{
      ngModule: ElMenuModule,
      providers: [
        ...EL_MENU_PROVIDERS,
      ],
    };
  }
}
